import clarity from '@microsoft/clarity';

/**
 * Custom hook for tracking events with Microsoft Clarity
 */
export const useClarity = () => {
  /**
   * Track a custom event in Clarity
   * @param name - The name of the event
   * @param data - Optional data to associate with the event
   */
  const trackEvent = (name: string, data?: Record<string, any>) => {
    try {
      // Use setTag to track events since Clarity doesn't have a direct event method
      clarity.setTag(name, JSON.stringify(data || {}));
      console.log(`Clarity event tracked: ${name}`, data);
    } catch (error) {
      console.error('Error tracking Clarity event:', error);
    }
  };

  /**
   * Track a page view in Clarity
   * @param page - The name of the page
   */
  const trackPageView = (page: string) => {
    try {
      // Use setTag to track page views
      clarity.setTag('page_view', page);
      console.log(`Clarity page view tracked: ${page}`);
    } catch (error) {
      console.error('Error tracking Clarity page view:', error);
    }
  };

  /**
   * Set a custom tag in Clarity
   * @param key - The key for the tag
   * @param value - The value for the tag
   */
  const setTag = (key: string, value: string) => {
    try {
      clarity.setTag(key, value);
      console.log(`Clarity tag set: ${key}=${value}`);
    } catch (error) {
      console.error('Error setting Clarity tag:', error);
    }
  };

  /**
   * Identify a user in Clarity
   * @param userId - The user ID
   */
  const identifyUser = (userId: string) => {
    try {
      clarity.identify(userId);
      console.log(`Clarity user identified: ${userId}`);
    } catch (error) {
      console.error('Error identifying user in Clarity:', error);
    }
  };

  return {
    trackEvent,
    trackPageView,
    setTag,
    identifyUser
  };
};
